import {BehaviorSubject, shareReplay, tap} from 'rxjs';
import {filter, map, startWith} from 'rxjs/operators';
import {wwData$} from '@/streams/worker-data';
import type {UAssetsFiatAccountData, UFiatAccounts} from '@px/ws-data';
import FiatDepositSuccessModal from '@/modules/fiat/components/FiatDepositSuccessModal.svelte';
import {popupUtil} from '@/helper/popup';
import {fiatAccountApi} from '@/api/fiat-account';

export const totalFiatAssets$ = wwData$.pipe(
  filter((o) => o.type === 'fiat-account-assets'),
  map((o: UAssetsFiatAccountData) => o.data.assets),
  startWith(initAssets())
);

export const fiatAccounts$ = wwData$.pipe(
  filter((o) => o.type === 'fiat-accounts'),
  map((o: UFiatAccounts) => o.data.accounts),
  startWith([])
);

function createFiatDepositSuccessModal() {
  let instance = null;
  return async function (info) {
    const item = info?.payload?.[0];
    if (!item) return;
    if (instance) {
      instance.$destroy();
    }
    await fiatAccountApi.fiatDepositConfirm({eventId: item.eventId, eventType: 'fiatDepositSuccess'});
    instance = popupUtil.create(FiatDepositSuccessModal, {info: info?.payload?.[0]});
    instance.$on('close', () => {
      instance.$destroy();
    });
  };
}

const fiatDepositInstance = createFiatDepositSuccessModal();

wwData$
  .pipe(
    filter((o) => o.type === 'fiat-deposit-success'),
    map((o) => o.data),
    startWith(null),
    tap((o) => fiatDepositInstance(o)),
    shareReplay(1)
  )
  .subscribe();

interface Option {
  text: string;
  value: string;
  name: string;
}

export const fiatAccountOptions$ = new BehaviorSubject<Option[]>([]);

fiatAccounts$
  .pipe(
    filter((fiatAccounts) => fiatAccounts.length > 0),
    map(convertFiatAccountOptions)
  )
  .subscribe((options) => fiatAccountOptions$.next(options));

function convertFiatAccountOptions(fiatAccount) {
  return fiatAccount.map(({currency}) => ({text: currency, value: currency, name: currency}));
}

function initAssets() {
  const BTC_PRECISION = 8;
  const USD_PRECISION = 2;
  return {
    isInit: true,
    btcEv: 0,
    btc: (0).toFixed(BTC_PRECISION),
    usdEv: 0,
    usd: (0).toFixed(USD_PRECISION),
    money: (0).toFixed(USD_PRECISION),
    usdtEv: 0,
    usdt: (0).toFixed(USD_PRECISION),
  };
}
